import Card from '../components/Card';
import { CreditCard, Trash2 } from 'lucide-react';
import type { PaymentAccount } from '../types';

const paymentAccounts: PaymentAccount[] = [
    {
        id: '1',
        type: 'paypal',
        account: 'user@example.com',
        isDefault: true
    },
    {
        id: '2',
        type: 'airtm',
        account: 'user123',
        isDefault: false
    }
];

export default function PaymentAccounts() {
    return (
        <div className="space-y-6">
            <h1 className="text-2xl font-bold text-gray-900">Payment Accounts</h1>

            <Card>
                <div className="mb-6">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4">Add New Account</h3>
                    <form className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Account Type
                            </label>
                            <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-navy-700 focus:border-navy-700">
                                <option value="paypal">PayPal</option>
                                <option value="airtm">Airtm</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Account Details
                            </label>
                            <input
                                type="text"
                                placeholder="Email or username"
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-navy-700 focus:border-navy-700"
                            />
                        </div>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-navy-700 text-white rounded-lg hover:bg-navy-800 transition-colors"
                        >
                            Add Account
                        </button>
                    </form>
                </div>

                <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-4">Your Accounts</h3>
                    <div className="space-y-4">
                        {paymentAccounts.map((account) => (
                            <div
                                key={account.id}
                                className="flex items-center justify-between p-4 border border-gray-200 rounded-lg"
                            >
                                <div className="flex items-center gap-4">
                                    <CreditCard size={24} className="text-navy-700" />
                                    <div>
                                        <h4 className="font-medium text-gray-900">
                                            {account.type.charAt(0).toUpperCase() + account.type.slice(1)}
                                        </h4>
                                        <p className="text-gray-600">{account.account}</p>
                                    </div>
                                    {account.isDefault && (
                                        <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded-full">
                      Default
                    </span>
                                    )}
                                </div>
                                <button className="p-2 text-red-500 hover:text-red-600 transition-colors">
                                    <Trash2 size={20} />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </Card>
        </div>
    );
}